const determineAttendancePermissions = ({ roles, sefRoles, workspaceDetails }) => {
  if (sefRoles.isGodAdmin) return true

  // must be participant so they should be able to view their own calendar
  if (!roles.length) return true

  const firstWorkspace = workspaceDetails[0]
  if (!firstWorkspace) return false

  const featureEnabled = firstWorkspace.attendances_enabled
  if (!featureEnabled) return false

  if (sefRoles.isWorkspaceAdmin) return true
  if (sefRoles.isWorkspaceProjectAdmin) return true
  if (sefRoles.isPartnerAdmin) return true
  if (sefRoles.isSuperAdmin) return true
  if (sefRoles.isWorksitePeopleAdmin) return true

  return false
}

const determineBudgetPermissions = ({ sefRoles, workspaceDetails }) => {
  if (sefRoles.isGodAdmin) return true

  const firstWorkspace = workspaceDetails[0]
  if (!firstWorkspace) return false

  const featureEnabled = firstWorkspace.purchase_requests_enabled
  if (!featureEnabled) return false

  if (sefRoles.isWorkspaceAdmin) return true
  if (sefRoles.isWorkspaceFinanceAdmin) return true
  if (sefRoles.isWorkspaceProcurementAdmin) return true
  if (sefRoles.isWorkspaceProjectAdmin) return true

  return false
}

const determinePartnersPermissions = ({ sefRoles }) => {
  if (sefRoles.isGodAdmin) return true

  if (sefRoles.isPartnerSigningAdmin) return true
  if (sefRoles.isPlatformAdmin) return true
  if (sefRoles.isWorkspaceAdmin) return true
  if (sefRoles.isWorkspaceProjectAdmin) return true

  return false
}

const determineEventPermissions = ({ sefRoles }) => {
  if (sefRoles.isGodAdmin) return true

  return false
}

const determineFormPermissions = ({ sefRoles }) => {
  if (sefRoles.isGodAdmin) return true

  if (sefRoles.isPlatformAdmin) return true
  if (sefRoles.isWorkspaceAdmin) return true
  if (sefRoles.isWorkspaceProjectAdmin) return true
  if (sefRoles.isWorkspaceSigningAdmin) return true

  return false
}

const determineReportPermissions = ({ sefRoles }) => {
  if (sefRoles.isGodAdmin) return true

  if (sefRoles.isPlatformAdmin) return true
  if (sefRoles.isWorkspaceAdmin) return true
  if (sefRoles.isWorkspaceProjectAdmin) return true

  return false
}

const determinePurchasesPermissions = ({ sefRoles, workspaceDetails = [] }) => {
  if (sefRoles.isGodAdmin) return true

  const firstWorkspace = workspaceDetails[0]
  if (!firstWorkspace) return false

  const featureEnabled = firstWorkspace.purchase_requests_enabled
  if (!featureEnabled) return false

  if (sefRoles.isWorkspaceAdmin) return true
  if (sefRoles.isWorkspaceFinanceAdmin) return true
  if (sefRoles.isWorkspaceOperationsAdmin) return true
  if (sefRoles.isWorkspaceOwner) return true
  if (sefRoles.isWorkspaceProcurementAdmin) return true
  if (sefRoles.isWorkspaceProjectAdmin) return true
  if (sefRoles.isPartnerAdmin) return true

  return false
}

const determineSuppliersPermissions = ({ sefRoles, workspaceDetails = [] }) => {
  if (sefRoles.isGodAdmin) return true

  const firstWorkspace = workspaceDetails[0]
  if (!firstWorkspace) return false

  const featureEnabled = firstWorkspace.purchase_requests_enabled
  if (!featureEnabled) return false

  if (sefRoles.isWorkspaceAdmin) return true
  if (sefRoles.isWorkspaceFinanceAdmin) return true
  if (sefRoles.isWorkspaceProcurementAdmin) return true
  if (sefRoles.isWorkspaceProjectAdmin) return true
  if (sefRoles.isPartnerAdmin) return true

  return false
}

const determineBulkActionPermissions = ({ sefRoles }) => {
  if (sefRoles.isGodAdmin) return true

  if (sefRoles.isPartnerTrainingAdmin) return true
  if (sefRoles.isPlatformAdmin) return true
  if (sefRoles.isWorkspaceAdmin) return true
  if (sefRoles.isWorkspaceProjectAdmin) return true

  return false
}

const determineOutputAreaPermissions = ({ sefRoles, workspaceDetails = [] }) => {
  if (sefRoles.isGodAdmin) return true

  const firstWorkspace = workspaceDetails[0]
  if (!firstWorkspace) return false

  const featureEnabled = firstWorkspace.outputs_enabled
  if (!featureEnabled) return false

  return (
    sefRoles.isPartnerAdmin ||
    sefRoles.isPartnerDistrictOutputsAdmin ||
    sefRoles.isWorksiteOutputsAdmin ||
    sefRoles.isWorksiteDataCollector ||
    sefRoles.isWorksiteDataStakeholder ||
    sefRoles.isWorkspaceAdmin ||
    sefRoles.isWorkspaceProjectAdmin
  )
}

const determineOutputsPermissions = ({ sefRoles, workspaceDetails = [] }) => {
  if (sefRoles.isGodAdmin) return true

  const firstWorkspace = workspaceDetails[0]
  if (!firstWorkspace) return false

  const featureEnabled = firstWorkspace.outputs_enabled
  if (!featureEnabled) return false

  return (
    sefRoles.isPartnerAdmin ||
    sefRoles.isPartnerDistrictOutputsAdmin ||
    sefRoles.isSuperAdmin ||
    sefRoles.isWorksiteOutputsAdmin ||
    sefRoles.isWorksiteDataCollector ||
    sefRoles.isWorksiteDataStakeholder ||
    sefRoles.isWorkspaceAdmin ||
    sefRoles.isWorkspaceProjectAdmin
  )
}

const determineParticipantPermissions = ({ sefRoles, workspaceDetails }) => {
  if (sefRoles.isGodAdmin) return true

  const firstWorkspace = workspaceDetails[0]
  if (!firstWorkspace) return false

  const featureEnabled = firstWorkspace.participant_management_enabled
  if (!featureEnabled) return false

  return (
    sefRoles.isPartnerDistrictPeopleAdmin ||
    sefRoles.isSuperAdmin ||
    sefRoles.isPartnerAdmin ||
    sefRoles.isPartnerSigningAdmin ||
    sefRoles.isPartnerTrainingAdmin ||
    sefRoles.isWorkspaceSigningAdmin ||
    sefRoles.isWorkspaceAdmin ||
    sefRoles.isWorkspaceProjectAdmin ||
    sefRoles.isWorksitePeopleAdmin
  )
}

const determinePayrollPermissions = ({ sefRoles, workspaceDetails = [] }) => {
  if (sefRoles.isGodAdmin) return true

  const firstWorkspace = workspaceDetails[0]
  if (!firstWorkspace) return false

  const featureEnabled = firstWorkspace.payroll_enabled
  if (!featureEnabled) return false

  if (sefRoles.isWorkspaceAdmin) return true
  if (sefRoles.isWorkspaceFinanceAdmin) return true
  if (sefRoles.isWorkspaceProjectAdmin) return true

  return false
}

const determinePayslipsPermissions = ({ sefRoles, workspaceDetails = [] }) => {
  if (sefRoles.isGodAdmin) return true

  const firstWorkspace = workspaceDetails[0]
  if (!firstWorkspace) return false

  const featureEnabled = firstWorkspace.payroll_enabled
  if (!featureEnabled) return false

  if (sefRoles.isWorkspaceAdmin) return true
  if (sefRoles.isWorkspaceFinanceAdmin) return true
  if (sefRoles.isWorkspaceProjectAdmin) return true
  if (sefRoles.isPartnerAdmin) return true

  return false
}

const determineAgreementPermissions = ({ sefRoles, workspaceDetails = [] }) => {
  if (sefRoles.isGodAdmin) return true

  const firstWorkspace = workspaceDetails[0]
  if (!firstWorkspace) return false

  const featureEnabled = firstWorkspace.document_management_enabled
  if (!featureEnabled) return false

  if (sefRoles.isWorkspaceAdmin) return true
  if (sefRoles.isWorkspaceProjectAdmin) return true
  if (sefRoles.isWorkspaceSigningAdmin) return true

  return false
}

const determineAdminPermissions = ({ sefRoles, workspaceDetails = [] }) => {
  if (sefRoles.isGodAdmin) return true

  const firstWorkspace = workspaceDetails[0]
  if (!firstWorkspace) return false

  if (sefRoles.isWorkspaceAdmin) return true
  if (sefRoles.isWorkspaceProjectAdmin) return true
  if (sefRoles.isWorkspaceSigningAdmin) return true

  return false
}

const determineWorksitesPermissions = ({ sefRoles, workspaceDetails = [] }) => {
  if (sefRoles.isGodAdmin) return true

  const firstWorkspace = workspaceDetails[0]
  if (!firstWorkspace) return false

  const featureEnabled =
    firstWorkspace.outputs_enabled ||
    firstWorkspace.participant_management_enabled ||
    firstWorkspace.attendances_enabled ||
    true // temporary so SEF SIPs can see worksites
  if (!featureEnabled) return false

  return (
    sefRoles.isWorkspaceAdmin ||
    sefRoles.isWorkspaceProjectAdmin ||
    sefRoles.isPartnerAdmin ||
    sefRoles.isWorksiteOutputsAdmin ||
    sefRoles.isWorksitePeopleAdmin ||
    sefRoles.isSuperAdmin
  )
}

const determineTrainingRecordsPermissions = ({
  isParticipant,
  sefRoles,
  workspaceDetails = []
}) => {
  if (isParticipant) return true
  if (sefRoles.isGodAdmin) return true

  const firstWorkspace = workspaceDetails[0]
  if (!firstWorkspace) return false

  const featureEnabled = firstWorkspace.ace_capabilities_enabled
  if (!featureEnabled) return false

  return (
    sefRoles.isWorkspaceAdmin ||
    sefRoles.isWorkspaceProjectAdmin ||
    sefRoles.isPartnerAdmin ||
    sefRoles.isPartnerTrainingAdmin ||
    sefRoles.isWorksitePeopleAdmin ||
    sefRoles.isSuperAdmin
  )
}

const determineSideHustlesPermissions = ({ isParticipant, sefRoles, workspaceDetails = [] }) => {
  if (isParticipant) return true
  if (sefRoles.isGodAdmin) return true

  const firstWorkspace = workspaceDetails[0]
  if (!firstWorkspace) return false

  const featureEnabled = firstWorkspace.ace_enterprise_enabled
  if (!featureEnabled) return false

  return (
    sefRoles.isWorkspaceAdmin ||
    sefRoles.isWorkspaceProjectAdmin ||
    sefRoles.isPartnerAdmin ||
    sefRoles.isWorksitePeopleAdmin ||
    sefRoles.isSuperAdmin
  )
}

const determineWorkRecordsPermissions = ({ isParticipant, sefRoles, workspaceDetails = [] }) => {
  if (isParticipant) return true
  if (sefRoles.isGodAdmin) return true

  const firstWorkspace = workspaceDetails[0]
  if (!firstWorkspace) return false

  const featureEnabled = firstWorkspace.ace_advancement_enabled
  if (!featureEnabled) return false

  return (
    sefRoles.isWorkspaceAdmin ||
    sefRoles.isWorkspaceProjectAdmin ||
    sefRoles.isPartnerAdmin ||
    sefRoles.isWorksitePeopleAdmin ||
    sefRoles.isSuperAdmin
  )
}

const determineIndicatorPermissions = ({ sefRoles, workspaceDetails = [] }) => {
  if (sefRoles.isGodAdmin) return true

  const firstWorkspace = workspaceDetails[0]
  if (!firstWorkspace) return false

  const featureEnabled = firstWorkspace.outputs_enabled
  if (!featureEnabled) return false

  return (
    sefRoles.isPartnerAdmin ||
    sefRoles.isPartnerDistrictOutputsAdmin ||
    sefRoles.isWorksiteOutputsAdmin ||
    sefRoles.isWorksiteDataCollector ||
    sefRoles.isWorksiteDataStakeholder ||
    sefRoles.isWorkspaceAdmin ||
    sefRoles.isWorkspaceProjectAdmin
  )
}

const determineDistrictsPermissions = ({ sefRoles, workspaceDetails }) => {
  if (sefRoles.isGodAdmin) return true

  const firstWorkspace = workspaceDetails[0]
  if (!firstWorkspace) return false

  const featureEnabled =
    firstWorkspace.outputs_enabled || firstWorkspace.participant_management_enabled
  if (!featureEnabled) return false

  if (sefRoles.isWorkspaceAdmin) return true
  if (sefRoles.isWorkspaceProjectAdmin) return true
  if (sefRoles.isPartnerAdmin) return true
  if (sefRoles.isPartnerDistrictOutputsAdmin) return true

  return false
}

const permissions = {
  admin: determineAdminPermissions,
  agreements: determineAgreementPermissions,
  areas: determineOutputAreaPermissions,
  attendances: determineAttendancePermissions,
  budgets: determineBudgetPermissions,
  bulkActions: determineBulkActionPermissions,
  districts: determineDistrictsPermissions,
  forms: determineFormPermissions,
  events: determineEventPermissions,
  indicators: determineIndicatorPermissions,
  outputs: determineOutputsPermissions,
  participants: determineParticipantPermissions,
  partners: determinePartnersPermissions,
  payroll: determinePayrollPermissions,
  payslips: determinePayslipsPermissions,
  purchases: determinePurchasesPermissions,
  reports: determineReportPermissions,
  sideHustles: determineSideHustlesPermissions,
  suppliers: determineSuppliersPermissions,
  trainingRecords: determineTrainingRecordsPermissions,
  workRecords: determineWorkRecordsPermissions,
  worksites: determineWorksitesPermissions
}

const checkRoutingPermissions = ({
  isParticipant,
  roles,
  sefRoles,
  workspaceDetails,
  featureName
}) => {
  const permissionCheck = permissions[featureName]
  if (!permissionCheck) return true

  return permissionCheck({ isParticipant, roles, sefRoles, workspaceDetails })
}

export default checkRoutingPermissions
